const ACCESS = {
  public: {
    icon: 'lock-open',
  },
  private: {
    icon: 'lock',
  },
  shared: {
    icon: 'share-alt',
  },
};

export default ACCESS;



// WEBPACK FOOTER //
// ./src/access.js